<template>
  <v-dialog v-model="dialog" max-width="600" >
    <template v-slot:activator="{ on, attrs }">
      <v-btn small icon v-bind="attrs" v-on="on"><v-icon small>mdi-information-outline</v-icon></v-btn>
    </template>
    <v-card>
      <v-card-title>Statistics</v-card-title>
      <v-card-text>
        <vue-plotly
          :data="data"
          :layout="layout"
          :options="options"
        />
        {{ this.stats }}
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn text @click="dialog=false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import VuePlotly from '@statnett/vue-plotly'
import Files from '@/api/files'
import Datasets from '@/api/datasets'
import Predictions from '@/api/predictions'
import Exports from '@/api/exports'
export default {
  name: "dlgStatistics",
  props: {
    column: { type: String, required: true },
  },
  components: {
    VuePlotly,
  },
  watch: {
    dialog(val) {
      if (val) {
        let path = this.$route.path.split('/').filter(n => n)
        this.mode = path[0]
        this.uuid = path[1]
        
        if (this.mode == 'files') {
          Files.stats(this.uuid, this.column).then(response => {
            this.data[0]['x'] = response.data.values
            this.data[0]['y'] = response.data.counts
          })
        } else if (this.mode == 'datasets') {
          Datasets.stats(this.uuid, this.column).then(response => {
            this.data[0]['x'] = response.data.values
            this.data[0]['y'] = response.data.counts
          })
        } else if (this.mode == 'predictions') {
          Predictions.stats(this.uuid, this.column).then(response => {
            this.data[0]['x'] = response.data.values
            this.data[0]['y'] = response.data.counts
          })
        } else if (this.mode == 'exports') {
          Exports.stats(this.uuid, this.column).then(response => {
            this.data[0]['x'] = response.data.values
            this.data[0]['y'] = response.data.counts
          })
        }
      }
    }
  },
  data() {
    return {
      dialog: false,
      mode: null,
      uuid: null,
      stats: null,
      data: [{
        name: this.column,
        x: [],
        y: [],
        type: 'bar', 
      }],
      layout: {
        autosize: true,
        barmode: "relative",
        showlegend: true,
        height: 250,
        legend: { x: 1, y: 1, xanchor: "right" },
        font: { family: "Roboto, sans-serif" },
        hovermode: "closest",
        margin: { l: 45, t: 15, r: 15, b: 45 },
        xaxis: { title: { text: `Values` }},
        yaxis: { title: { text: `Count (N)` }, type: "log" },
        paper_bgcolor: "#ffffff",
        plot_bgcolor: "#ffffff"
      },
      options: { displayModeBar: false, responsive: true }
    }
  }
}
</script>